"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var content_accessor_1 = require("../content-accessor");

var util_1 = require("../util");

var contentful_content_accessor_1 = require("./contentful-content-accessor");

var DefaultLocaleContentfulContentAccessor =
/** @class */
function (_super) {
  __extends(DefaultLocaleContentfulContentAccessor, _super);

  function DefaultLocaleContentfulContentAccessor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DefaultLocaleContentfulContentAccessor.prototype.accessBaseFor = function (fieldName) {
    var _a, _b;

    return util_1.readDefaultLocalizationFrom((_b = (_a = this.base) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b[fieldName]);
  };

  DefaultLocaleContentfulContentAccessor.prototype.field = function (fieldName) {
    return this.accessBaseFor(fieldName) ? new DefaultLocaleContentfulContentAccessor(this.accessBaseFor(fieldName)) : new content_accessor_1.NullAccessor();
  };

  DefaultLocaleContentfulContentAccessor.prototype.array = function (fieldName) {
    var _a;

    return (_a = this.accessBaseFor(fieldName), _a !== null && _a !== void 0 ? _a : []).map(function (v) {
      return new DefaultLocaleContentfulContentAccessor(v);
    });
  };

  return DefaultLocaleContentfulContentAccessor;
}(contentful_content_accessor_1.ContentfulContentAccessor);

exports.DefaultLocaleContentfulContentAccessor = DefaultLocaleContentfulContentAccessor;